import { Col, Form as BSForm, Row } from 'react-bootstrap';
import ReactDatePicker from 'react-datepicker';
import { useFormikContext } from 'formik';
import SigniteButton from '../../../../ui-elements/signite-button/signiteButton';
import { getErrorClass, getErrorMessage } from '../../../../../utils/errorUtils';
import { useRef } from 'react';
import { CandidateService } from '../../../../../services/candidateService';
import Loader from 'react-spinner-loader';
import { useState } from 'react';
import { faMinusCircle } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

export const AwardsForm = ({ values, handleChange, award, index, handleBlur, errors, touched }) => {
  const [loader, setLoader] = useState(false);
  const { setFieldValue } = useFormikContext();
  const fileUploadHandler = (data) => {
    setFieldValue(`awards.${index}.awardDoc[0].originalName`, data.originalName);
    setFieldValue(`awards.${index}.awardDoc[0].path`, data.path);
  };
  const inputFile = useRef(null);

  const handleFileChange = (event) => {
    if (event.target.files[0]) {
      console.log('File selection captured!', event.target.files[0]);
      const formData = new FormData();
      formData.append('file', event.target.files[0]);

      CandidateService.uploadFile(formData, 'AWARD', fileUploadHandler, setLoader);
    }
  };

  const handleDownload = (type, filePath, fileName) => {
    CandidateService.downloadFile(type, encodeURIComponent(filePath))
      .then((response) => {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const a = document.createElement('a');
        a.href = url;
        a.download = fileName;
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
        window.URL.revokeObjectURL(url);
      })
      .catch((err) => console.error(err));
  };


  const removeFile = (field) => {
    setFieldValue(field, []);
    inputFile.current.value = '';
  };
  return (
    <div className="signite-form">
      <Loader show={loader} type="body" stack="vertical" message="Loading Data" />
      <Row className="mb-3">
        <BSForm.Group as={Col}>
          <BSForm.Label>Title</BSForm.Label>
          <BSForm.Control
            type="text"
            name={`awards.${index}.title`}
            onChange={handleChange}
            onBlur={handleBlur}
            className={`form-control ${getErrorClass(errors, touched, `awards.${index}.title`)}`}
            value={award.title}
          />
          <span className="errorMessage">{getErrorMessage(errors, touched, `awards.${index}.title`)}</span>
        </BSForm.Group>
        <BSForm.Group as={Col}>
          <BSForm.Label>Provided By</BSForm.Label>
          <BSForm.Control
            type="text"
            name={`awards.${index}.providedBy`}
            onChange={handleChange}
            onBlur={handleBlur}
            className={`form-control ${getErrorClass(errors, touched, `awards.${index}.providedBy`)}`}
            value={award.providedBy}
          />
          <span className="errorMessage">{getErrorMessage(errors, touched, `awards.${index}.providedBy`)}</span>
        </BSForm.Group>
        <BSForm.Group as={Col}>
          <BSForm.Label>Issue Year</BSForm.Label>
          <ReactDatePicker
            name={`awards.${index}.issueYear`}
            selected={
              _.get(values, `awards.${index}.issueYear`)
                ? new Date(new Date().setFullYear(_.get(values, `awards.${index}.issueYear`)))
                : null
            }
            onChange={(val) => {
              console.log(val);
              setFieldValue(`awards.${index}.issueYear`, val.getFullYear(), true);
            }}
            onBlur={handleBlur}
            className={`form-control ${getErrorClass(errors, touched, `awards.${index}.issueYear`)}`}
            dateFormat="yyyy"
            maxDate={new Date()}
            showYearPicker
            autoComplete="off"
          />
          <span className="errorMessage">{getErrorMessage(errors, touched, `awards.${index}.issueYear`)}</span>
        </BSForm.Group>
      </Row>
      <Row style={{ paddingLeft: 20 }}>
        <div className="file-upload d-flex align-items-center">
          <BSForm.Group as={Col} controlId={'fileUpload'}>
            <SigniteButton variant="primary" className="signiteUploadButton" onClick={() => inputFile.current.click()}>
              Browse..
            </SigniteButton>
            <input
              type="file"
              id="file"
              ref={inputFile}
              onChange={handleFileChange}
              style={{ display: 'none' }}
              accept=".doc,.docx,.pdf"
            />
            <BSForm.Label style={{ marginLeft: 5, fontSize: 16 }}>
              {(_.get(values, `awards.${index}.awardDoc[0].originalName`) && (
                <span>
                  <a
                    style={{ cursor: 'pointer', color: '#eb4b15' }}
                    onClick={() =>
                      handleDownload(
                        "AWARD",
                        _.get(values, `awards.${index}.awardDoc[0].path`),
                        _.get(values, `awards.${index}.awardDoc[0].originalName`)
                      )
                    }
                  >
                    {_.get(values, `awards.${index}.awardDoc[0].originalName`)}
                  </a>

                  <a
                    onClick={() => removeFile(`awards.${index}.awardDoc[0]`)}
                    style={{ marginLeft: 5, cursor: 'pointer', color: '#eb4b15' }}
                  >
                    <FontAwesomeIcon icon={faMinusCircle} size="sm" /> <span>Remove</span>
                  </a>
                </span>
              )) || `Or drop file here`}
            </BSForm.Label>
            <input type="hidden" name={`awards.${index}.awardDoc[0].originalName`} />
            <input type="hidden" name={`awards.${index}.awardDoc[0].path`} />
          </BSForm.Group>
        </div>
      </Row>
    </div>
  );
};